import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyS, HeadlineM } from '@sorare/core/src/atoms/typography';

const Root = styled(Vertical)`
  padding: calc(10 * var(--unit)) 0;
`;

type Props = { subtitle?: ReactNode; cta?: ReactNode; isToday?: boolean };
export const EmptyState = ({ subtitle, cta, isToday = false }: Props) => {
  return (
    <Root center gap={2}>
      <Vertical center gap={0}>
        <HeadlineM bold>
          {isToday ? (
            <FormattedMessage defaultMessage="No Games Today" />
          ) : (
            <FormattedMessage defaultMessage="No Games" />
          )}
        </HeadlineM>
        <BodyS color="var(--c-nd-600)">{subtitle}</BodyS>
      </Vertical>
      {cta}
    </Root>
  );
};
